module.exports = __webpack_public_path__ + "static/media/drag.78ab36d4.svg";